export default "__VITE_ASSET__30518ab8__"